import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { statusOptions } from './utils'

export const AgentStatusSelect = (props: SelectProps) => {
  const { t } = useTranslation()

  return (
    <Select
      style={{ minWidth: 150 }}
      allowClear
      options={statusOptions(t)}
      placeholder={t('status')}
      {...props}
    />
  )
}
